import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';

const ActionsWrapper = styled('div')`
  width: 100%;
  max-width: 60%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  z-index: 10;
  font-size: 14px;
  ${media.phone`
    max-width: 100%;
  `}
`;

const Actions = styled('div')`
  display: flex;
  align-items: stretch;
`;

const Action = styled('div')`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  background-color: white;
  color: black;
  &:hover {
    background-color: darkgray;
    color: white;
  }
  .active {
    background-color: black;
    color: white;
  }
  transition: all 300ms ease-in-out;
`;

const MainAction = styled('div')`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  background-color: black;
  color: white;
  &:hover {
    background-color: darkgray;
  }
  &:active {
    background-color: darkgray;
  }
  transition: all 300ms ease-in-out;
`;

const AdditionInfo = styled('div')`
  min-height: 50px;
  font-size: 10px;
  padding: 5px;
  background-color: white;
  ul li {
    list-style: none;
  }
`;

const BackButton = styled('div')`
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  font-size: 14px;
  &:hover {
    background-color: darkgray;
  }
  transition: all 300ms ease-in-out;
  ${media.phone`
    max-width: 100%;
  `}
`;

class ActionsWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProducts: false,
      showHyperpigmentation: false,
      activeAction: null,
    };
    props.setFooterVisible(false);
  }

  handleOnClick = ({ method: { sdk: sdkMethod, module, method, parameters, deactivate }, actionIndex }) => {
    const { sdk, triggerCallback, options } = this.props;
    const { activeAction } = this.state;
    if (!sdkMethod) {
      this[method]();
    } else {
      if (deactivate && actionIndex === activeAction) {
        try {
          sdk[deactivate.module][deactivate.method](...deactivate.parameters);
        } catch (e) {
          console.error('Invalid SDK method');
          console.log(e.message);
        }
        this.setState({ activeAction: null });
      } else {
        try {
          sdk[module][method](...parameters);
        } catch (e) {
          console.error('Invalid SDK method');
          console.log(e.message);
        }
        if (typeof activeAction !== 'undefined') this.setState({ activeAction: actionIndex });
      }
    }
    if (actionIndex === undefined) {
      triggerCallback({ callback: 'action', payload: options.mainAction.label });
    } else {
      triggerCallback({ callback: 'action', payload: options.actions[actionIndex].label });
    }
  };

  handleProductsBack = () => {
    const { setFooterVisible } = this.props;
    setFooterVisible(false);
    setTimeout(() => this.setState({ showProducts: false }), 500);
  };

  showProducts = () => {
    const { setFooterVisible } = this.props;
    setFooterVisible(true);
    this.setState({ showProducts: true });
  };

  handleHyperpigmentationBack = () => {
    const { sdk } = this.props;
    sdk.AR.dehighlightAll();
    this.setState({ showHyperpigmentation: false });
  };

  showHyperpigmentation = () => {
    const { sdk } = this.props;
    sdk.AR.highlightHyperpigmentationIndividually();
    this.setState({ showHyperpigmentation: true });
  };

  render = () => {
    const {
      options: { actions, mainAction, additionalInfo },
    } = this.props;
    const { showProducts, showHyperpigmentation, activeAction } = this.state;

    return (
      <ActionsWrapper className="revieveActionsWrapper">
        {showProducts ? (
          <BackButton className="revieveActionsBack" onClick={this.handleProductsBack}>
            Back
          </BackButton>
        ) : showHyperpigmentation ? (
          <BackButton className="revieveActionsBack" onClick={this.handleHyperpigmentationBack}>
            Hide hyperpigmentation spots
          </BackButton>
        ) : (
          <div>
            <Actions className="revieveActions">
              {actions.map((action, index) => (
                <Action
                  className={`revieveAction ${activeAction === index ? 'active' : null}`}
                  key={`action${index}`}
                  onClick={() => this.handleOnClick({ method: action.onClick, actionIndex: index })}
                >
                  {action.label}
                </Action>
              ))}
            </Actions>
            {mainAction && (
              <MainAction
                className="revieveMainAction"
                onClick={() => this.handleOnClick({ method: mainAction.onClick })}
              >
                {mainAction.label}
              </MainAction>
            )}
          </div>
        )}
        {additionalInfo && (
          <AdditionInfo className="revieveAdditionalInfo">
            <ul>
              {additionalInfo.map((info, index) => (
                <li key={`additionaInfo-${index}`}>{info}</li>
              ))}
            </ul>
          </AdditionInfo>
        )}
      </ActionsWrapper>
    );
  };
}

export default ActionsWidget;



// WEBPACK FOOTER //
// ./src/components/instore/ActionsWidget.js